import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConstantsService {

        Aplications = {
            1: 'IACUC',
            2: 'AP',
            3: 'BILLING',
            8: 'AI',
            11: 'SC',
            12: 'VC',
            14: 'RS'
        };
        
        DBActions = {
            Insert: 0,
            Update: 1,
            Delete: 2
        };

    LoginTypes = {
        Cayuse: 'cayuse',
        SSO: 'sso'
    }

        DailyPlanLevels = {
            LEVEL1: "LEVEL1",
            LEVEL2: "LEVEL2",
            LEVEL3: "LEVEL3"
        };

        ForecastMode = {
            CurrentForecast: 0,
            Scenario: 1
        };

        FaciltyAreaViewType = {
            Facility: 1,
            Area: 0
        };

        SectionType = {
            Grid: 0,
            Dashboard: 1,
            GeneralPage: 2,
            Report: 3,
            Calendar: 4
        };

        Dates = {
            WeekAStartsOn: '01-07-2018'
        };

        ProgressBarLoadingSpeed = {
            Quick: 0,
            Moderate: 1,
            Slow: 2
        };

        ActivityIcons = {
            iconStyles: {
                solid: { name: 'solid', className: 'fa' },
                regular: { name: 'regular', className: 'far' },
                light: { name: 'light', className: 'fal' }
            },

            iconAnimations: {
                none: { name: 'none', className: '' },
                spin: { name: 'spin', className: 'spin' },
                pulse: { name: 'pulse', className: 'pulse' }
            },
        };

        ActivityTypes = {
            Room: 1,
            Rack: 2,
            Cage: 3,
            Staff: 4,
            FacilityArea: 5,
            Area: 6, //unnecessary Anymore
            Equipment: 7,
            Preparation: 8,
            QCCheck: 9,


            RackIcon: 'far fa-table',
            CompletedActivityIcon: {
                icon: 'fa fa-check-circle',
                color: '#0c9d58',
                size: '30px'
            },

            getIcon: (iconSrc) => {

                if (iconSrc) {
                    var icon = iconSrc.split(';');
                    if (icon.length > 2) {
                        return '' + (icon[2] && this.ActivityIcons.iconStyles[icon[2]] ? this.ActivityIcons.iconStyles[icon[2]].className : this.ActivityIcons.iconStyles[this.ActivityIcons.iconStyles.solid.name].className)
                            + ' fa-' + (icon[0])
                            + ' fa-' + (icon.length === 4 ? this.ActivityIcons.iconAnimations[icon[3]].className : this.ActivityIcons.iconAnimations.none.className);

                    }
                }

                return '';
            },

            getIconSrc: (activity) => {

                if (activity.activityIcon) {
                    var icon = activity.activityIcon.split(';');
                    if (icon.length > 2) {
                        return  '' + (icon[2] && this.ActivityIcons.iconStyles[icon[2]] ? this.ActivityIcons.iconStyles[icon[2]].className : this.ActivityIcons.iconStyles[this.ActivityIcons.iconStyles.solid.name].className)
                            + ' fa-' + (icon[0])
                            + ' fa-' + (icon.length === 4 ? this.ActivityIcons.iconAnimations[icon[3]].className : this.ActivityIcons.iconAnimations.none.className);
                    }
                }

                switch (activity.typeId) {
                    case this.ActivityTypes.Room: return 'fal fa-key';
                    case this.ActivityTypes.Rack: return 'fal fa-th';
                    case this.ActivityTypes.Cage: return 'fal fa-cube';
                    case this.ActivityTypes.Staff: return 'fal fa-user';
                    case this.ActivityTypes.FacilityArea: case this.ActivityTypes.Area: return 'fal fa-building';
                    case this.ActivityTypes.Equipment: return 'fal fa-tags';
                    case this.ActivityTypes.Preparation: return 'fal fa-shapes';
                    case this.ActivityTypes.QCCheck: return 'fas fa-badge-check';
                }

                return '';
            },

            getIconColor: function (activityIcon) {

                if (activityIcon) {
                    var icon = activityIcon.split(';');
                    if (icon[1] && icon[1] !== '') {
                        return icon[1];
                    }
                }

                return '#757575';
            }
        };

        QuantityTypes = {
            CageCount: 1,
            PercentageOfCageCount: 2,
            ItemCount: 3,
            ItemCountSubtractedFromCageCount: 4,
        }

        ActivityCategory = {
            Room: 1,
            Facility: 2,
            Area: 3,
            Staff: 4
        };

        ForecastSchedulingMode = {
            Staff: 'STAFF',
            Room: 'ROOM'
        };

        ForecastActivityTypes = {
            RoomActivities: 'Room Activities',
            OtherActivities: 'Other Activities'
        };

        ActivityStatus = {
            NotStarted: 1,
            InProgress: 2,
            Completed: 3,
            Cancelled: 4,
            Lapsed: 5,
            Replaced: 6
        };

        DayNames = {
            SUNDAY: 'Sunday',
            MONDAY: 'Monday',
            TUESDAY: 'Tuesday',
            WEDNESDAY: 'Wednesday',
            THURSDAY: 'Thursday',
            FRIDAY: 'Friday',
            SATURDAY: 'Saturday'
        };

        DaysOfTheWeekLabels = {
            SUNDAY: { dayIndex: 0, label: 'Sunday', lowerCaseLabel: 'sunday', shortLabel: 'Sun', abbreviationLabel: 'Su' },
            MONDAY: { dayIndex: 1, label: 'Monday', lowerCaseLabel: 'monday', shortLabel: 'Mon', abbreviationLabel: 'M' },
            TUESDAY: { dayIndex: 2, label: 'Tuesday', lowerCaseLabel: 'tuesday', shortLabel: 'Tue', abbreviationLabel: 'Tu' },
            WEDNESDAY: { dayIndex: 3, label: 'Wednesday', lowerCaseLabel: 'wednesday', shortLabel: 'Wed', abbreviationLabel: 'W' },
            THURSDAY: { dayIndex: 4, label: 'Thursday', lowerCaseLabel: 'thursday', shortLabel: 'Thu', abbreviationLabel: 'Th' },
            FRIDAY: { dayIndex: 5, label: 'Friday', lowerCaseLabel: 'friday', shortLabel: 'Fri', abbreviationLabel: 'F' },
            SATURDAY: { dayIndex: 6, label: 'Saturday', lowerCaseLabel: 'saturday', shortLabel: 'Sat', abbreviationLabel: 'S' },

            getDaysOfTheWeekLabels: function (labelType) {
                var selectedLabelType = labelType ? labelType : 'label';
                var dayLabelsArray = [];

                for (var dayOfTheWeek in this) {
                    if (this.hasOwnProperty(dayOfTheWeek) && (this[dayOfTheWeek].dayIndex || this[dayOfTheWeek].dayIndex === 0) && this[dayOfTheWeek][selectedLabelType]) {
                        dayLabelsArray.push({ dayIndex: this[dayOfTheWeek].dayIndex, label: this[dayOfTheWeek][selectedLabelType] });
                    }
                }

                return dayLabelsArray;
            }
        };

        Months = {
            January: { value: 0, label: 'January' },
            February: { value: 1, label: 'February' },
            March: { value: 2, label: 'March' },
            April: { value: 3, label: 'April' },
            May: { value: 4, label: 'May' },
            June: { value: 5, label: 'June' },
            July: { value: 6, label: 'July' },
            August: { value: 7, label: 'August' },
            September: { value: 8, label: 'September' },
            October: { value: 9, label: 'October' },
            November: { value: 10, label: 'November' },
            December: { value: 11, label: 'December' },

            getLabelByEnumValue: function (enumValue) {
                for (var month in this) {
                    if (this.hasOwnProperty(month) && this[month].value === enumValue) {
                        return this[month].label;
                    }
                }
            },

            getByValue: function (value) {

                for (var key in this) {
                    if (this.hasOwnProperty(key) && this[key].value === value) {
                        return this[key];
                    }
                }

                return null;
            }
        };

        DayLabels = {

            labels: [
                { label: 'Su', dayOfWeek: 0 },
                { label: 'M', dayOfWeek: 1 },
                { label: 'Tu', dayOfWeek: 2 },
                { label: 'W', dayOfWeek: 3 },
                { label: 'Th', dayOfWeek: 4 },
                { label: 'F', dayOfWeek: 5 },
                { label: 'S', dayOfWeek: 6 }
            ],

            getLabel: function (date) {
                var dayOfWeekNumber = date.day();
                return this.labels.firstOrDefault(function (dowLabel) {
                    return dowLabel.dayOfWeek === dayOfWeekNumber;
                }).label;
            }
        };

        StaffAttendTypes = {
            On: 'on',
            Off: 'off',
            PTO: 'PTO',

            isStaffPresent: function (attendType) {
                return attendType && attendType.toString().toLowerCase() === this.On.toLowerCase();
            },

            isPTO: function (attendType) {
                return attendType && attendType.toString().toLowerCase() === this.PTO.toLowerCase();
            },

            isOff: function (attendType) {
                return attendType && attendType.toString().toLowerCase() === this.Off.toLowerCase();
            },

            formatStaffAttendType: function (attendType) {
                return this.isPTO(attendType) ? this.PTO : attendType;
            }
        };

        DropDownBlankLabels = {
            NoRole: 'No role',
            NoArea: 'No area',
            NoRoomType: 'No room type',
            NoSpecies: 'No species',
            NoRackType: 'No rack type'
        };

        Recurrence = {
            Patterns: {
                DAILY: { value: 0, name: 'Daily' },
                WEEKLY: {
                    value: 1,
                    name: 'Weekly',
                    Options: {
                        Every_Weekday: { value: 0, name: 'Every Weekday' },
                        Every_Weekend_Day: { value: 1, name: 'Every Weekend Day' },
                        Every_dow: { value: 2, name: 'Every' },
                        Every_day: { value: 3, name: 'Every' },
                        Biweekly_Cycle: {
                            value: 6, name: 'Biweekly A/B cycle', Options: {
                                Week1: { value: 1, name: 'Week A' },
                                Week2: { value: 2, name: 'Week B' }
                            }
                        },
                        Every_Week: { value: 7, name: 'Every week' },
                        Weekly_Cycle: {
                            value: 8, name: 'Weekly cycle', Options: {
                                Week1: { value: 1, name: 'Week A' },
                                Week2: { value: 2, name: 'Week B' },
                                Every_Week: { value: 5, name: 'Every week' },

                                getByValue: function (value) {

                                    for (var key in this) {
                                        if (this.hasOwnProperty(key) && this[key].value === value) {
                                            return this[key];
                                        }
                                    }

                                    return null;
                                }
                            }
                        },
                    }
                },
                MONTHLY: { value: 2, name: 'Monthly' },
                YEARLY: {
                    value: 3,
                    name: 'Yearly',
                    Options: {
                        On_Anniversary: { value: 4, name: 'On' },
                        On_Selection: { value: 5, name: 'On the' }
                    }
                },
                SHARED: { value: 4, name: 'Shared' }
            },

            WhenOptions: {
                ANYTIME: { value: 0, name: 'Anytime' },
                AM: { value: 1, name: 'AM' },
                PM: { value: 2, name: 'PM' },
                MIDDAY: { value: 3, name: 'Midday' },
                SPECIFIC_TIME: { value: 4, name: 'Specific Time' },
                TIME_INTERVALS: { value: 5, name: 'Time Intervals' },

                getByValue: function (value) {

                    for (var key in this) {
                        if (this.hasOwnProperty(key) && this[key].value === value) {
                            return this[key];
                        }
                    }

                    return null;
                }
            },

            ScheduleRacksOptions: {
                On_Same_Days: { value: 'false', label: 'same' },
                On_Different_Days: { value: 'true', label: 'different' },

                getByValue: function (value) {

                    for (var key in this) {
                        if (this.hasOwnProperty(key) && this[key].value === value) {
                            return this[key];
                        }
                    }

                    return null;
                }
            },

            RecurrenceActivitySetup: {
                RoomActivity: { value: 0, table: 'RSRMACT' },
                RoomTemplate: { value: 1, table: 'RSTMPLAC' },
                StaffActivity: { value: 2, table: 'RSSFACT' },
                LocationActivity: { value: 3, table: 'RSGLACT' },
                SharedRecurrence: { value: 4, table: 'RECSHR' },

                getValueByTableName: function (tableName) {

                    switch (tableName) {

                        case this.RoomActivity.table:
                            return this.RoomActivity.value;
                        case this.RoomTemplate.table:
                            return this.RoomTemplate.value;
                        case this.StaffActivity.table:
                            return this.StaffActivity.value;
                        case this.LocationActivity.table:
                            return this.LocationActivity.value;
                        case this.SharedRecurrence.table:
                            return this.SharedRecurrence.value;
                        default:
                            return -1;
                    }
                }
            },

            DayPrefixes: {
                FIRST: { value: 0, label: 'first' },
                SECOND: { value: 1, label: 'second' },
                THIRD: { value: 2, label: 'third' },
                FOURTH: { value: 3, label: 'fourth' },
                LAST: { value: 4, label: 'last' },

                getByValue: function (value) {

                    for (var key in this) {
                        if (this.hasOwnProperty(key) && this[key].value === value) {
                            return this[key];
                        }
                    }

                    return null;
                }
            },

            MonthlyDays: {
                DAY: { value: 0, label: 'day' },
                WEEKDAY: { value: 1, label: 'weekday' },
                SUNDAY: { value: 3, label: this.DayNames.SUNDAY },
                MONDAY: { value: 4, label: this.DayNames.MONDAY },
                TUESDAY: { value: 5, label: this.DayNames.TUESDAY },
                WEDNESDAY: { value: 6, label: this.DayNames.WEDNESDAY },
                THURSDAY: { value: 7, label: this.DayNames.THURSDAY },
                FRIDAY: { value: 8, label: this.DayNames.FRIDAY },
                SATURDAY: { value: 9, label: this.DayNames.SATURDAY },

                getByValue: function (value) {

                    for (var key in this) {
                        if (this.hasOwnProperty(key) && this[key].value === value) {
                            return this[key];
                        }
                    }

                    return null;
                }
            }
        };

        TodaysAssignments = {

            Levels: {
                HomePage: 1,
                RoomGroups: 2,
                RackDetails: 3,
                ActivityDetails: 4,
                PreparationList: 5
            },

            RoomRackCensus: {
                RackCensusUpdatedStatusIcons: {
                    UpdateOverdue: {
                        icon: 'fa fa-exclamation-triangle',
                        color: 'red',
                        size: '16px'
                    },
                    UpdateUpcoming: {
                        icon: 'fa fa-exclamation-circle',
                        color: 'orange',
                        size: '16px'
                    },
                    RecentlyUpdated: {
                        icon: 'fa fa-check-circle',
                        color: 'green',
                        size: '16px'
                    },
                }
            }
        };

        MainMenu = {
            Types: {
                Default: 'Default',
                Setup: 'Setup'
            },
            HideMenuItems: ['dailyplan', 'forecast', 'todaysassignments']
        };

        TabNames = {
            Default: 'Cayuse'
        };

        DurationSplitFormats = {
            HMS: 'HMS',
            HM: 'HM',
            HMMid: 'HMMid',
            HMLong: 'HMLong',
            HShort: 'HShort',
            Hlong: 'Hlong'
       };

    HtmlElementNames = {
        RefreshFrameId: 'refresh-frame'
    }

    AppDisplayTypes = {
        Home: 'home',
        Grid: 'grid',
        Preview: 'preview'
    }
}
